export default __webpack_public_path__ + "a1d11b8f648087b028b81ed71aaaf2be.png";